import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { CommonService } from "src/app/_services/common.service";
import { lastValueFrom } from "rxjs";

@Injectable()
export class TranslationService {

  public language = "en";
  private _translation: any;

  constructor(private http: HttpClient, private commonService: CommonService) {
    this.initialize();
  }

  public async initialize() {
    try {
      const lang = localStorage.getItem('lang');
      // const resp = await this.http.get(`/assets/json/EMSaaSTranslationData/json/${lang}.json`).toPromise();
      const resp = await lastValueFrom(this.commonService.getTranslation(lang));
      this._translation = resp?.data ? resp.data : resp;
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  translate(key: string): string {
    if (this._translation && this._translation[key])
      return this._translation[key];
    else
      return key;
  }
}
